import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { 
  ShoppingCart, 
  Search, 
  Plus, 
  Eye,
  Download,
  Calendar,
  Filter,
  X,
  Save
} from 'lucide-react';

const Sales = () => {
  const [sales, setSales] = useState([
    {
      id: 1,
      transactionNumber: 'VTA-2025-001',
      date: '2025-01-15',
      time: '14:30',
      customer: 'María González',
      products: [
        { name: 'Vino Tannat Reserva', quantity: 2, unitPrice: 850, total: 1700 }
      ],
      total: 1700,
      paymentMethod: 'Efectivo'
    },
    {
      id: 2,
      transactionNumber: 'VTA-2025-002',
      date: '2025-01-16',
      time: '16:45',
      customer: 'Juan Pérez',
      products: [
        { name: 'Vino Merlot', quantity: 3, unitPrice: 720, total: 2160 },
        { name: 'Queso Artesanal', quantity: 1, unitPrice: 580, total: 580 }
      ],
      total: 2740,
      paymentMethod: 'Transferencia'
    },
    {
      id: 3,
      transactionNumber: 'VTA-2025-003',
      date: '2025-01-17',
      time: '11:20',
      customer: 'Ana Rodríguez',
      products: [
        { name: 'Aceite de Oliva Premium', quantity: 2, unitPrice: 450, total: 900 }
      ],
      total: 900,
      paymentMethod: 'Tarjeta'
    }
  ]);

  const [searchTerm, setSearchTerm] = useState('');
  const [filterDate, setFilterDate] = useState('');
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [selectedSale, setSelectedSale] = useState(null);

  const filteredSales = sales.filter(sale => {
    const matchesSearch = sale.transactionNumber.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         sale.customer.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesDate = !filterDate || sale.date === filterDate;
    return matchesSearch && matchesDate;
  });

  const handleExportCSV = () => {
    alert('Exportando ventas a CSV (simulado)');
  };

  const handleAddSale = () => {
    alert('Formulario para agregar nueva venta (simulado)');
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-gray-800 flex items-center gap-3">
            <ShoppingCart className="h-8 w-8" style={{color: '#D4AF37'}} />
            Registro de Ventas
          </h1>
          <p className="text-gray-600 mt-1">Administra y consulta todas las ventas</p>
        </div>
        <div className="flex gap-2">
          <button
            onClick={handleExportCSV}
            className="flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
          >
            <Download className="h-5 w-5" />
            Exportar CSV
          </button>
          <button
            onClick={() => setShowAddModal(true)}
            className="flex items-center gap-2 px-6 py-2 text-white rounded-lg hover:opacity-90 transition-opacity shadow-lg"
            style={{background: 'linear-gradient(135deg, #D4AF37 0%, #C9A961 100%)'}}
          >
            <Plus className="h-5 w-5" />
            Nueva Venta
          </button>
        </div>
      </div>

      {/* Stats */}
      <div className="grid md:grid-cols-3 gap-6">
        <div className="bg-white rounded-lg shadow-md p-6">
          <h3 className="text-sm font-medium text-gray-600">Total Ventas Hoy</h3>
          <p className="text-3xl font-bold mt-2" style={{color: '#D4AF37'}}>USD 5.340</p>
          <p className="text-sm text-gray-500 mt-1">3 transacciones</p>
        </div>
        <div className="bg-white rounded-lg shadow-md p-6">
          <h3 className="text-sm font-medium text-gray-600">Promedio por Venta</h3>
          <p className="text-3xl font-bold mt-2 text-gray-800">USD 1.780</p>
        </div>
        <div className="bg-white rounded-lg shadow-md p-6">
          <h3 className="text-sm font-medium text-gray-600">Ventas del Mes</h3>
          <p className="text-3xl font-bold mt-2 text-green-600">USD 45.230</p>
          <p className="text-sm text-gray-500 mt-1">28 transacciones</p>
        </div>
      </div>

      {/* Filters */}
      <div className="bg-white rounded-lg shadow-md p-4">
        <div className="grid md:grid-cols-2 gap-4">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
            <input
              type="text"
              placeholder="Buscar por número de transacción o cliente..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent"
            />
          </div>
          <div className="relative">
            <Calendar className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
            <input
              type="date"
              value={filterDate}
              onChange={(e) => setFilterDate(e.target.value)}
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent"
            />
          </div>
        </div>
      </div>

      {/* Sales Table */}
      <div className="bg-white rounded-lg shadow-md overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead style={{background: 'linear-gradient(135deg, #D4AF37 0%, #C9A961 100%)'}}>
              <tr>
                <th className="px-6 py-4 text-left text-sm font-semibold text-white">Nº Transacción</th>
                <th className="px-6 py-4 text-left text-sm font-semibold text-white">Fecha y Hora</th>
                <th className="px-6 py-4 text-left text-sm font-semibold text-white">Cliente</th>
                <th className="px-6 py-4 text-left text-sm font-semibold text-white">Productos</th>
                <th className="px-6 py-4 text-left text-sm font-semibold text-white">Método Pago</th>
                <th className="px-6 py-4 text-left text-sm font-semibold text-white">Total</th>
                <th className="px-6 py-4 text-center text-sm font-semibold text-white">Acciones</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {filteredSales.map((sale) => (
                <tr key={sale.id} className="hover:bg-gray-50 transition-colors">
                  <td className="px-6 py-4 text-sm font-mono text-gray-700">{sale.transactionNumber}</td>
                  <td className="px-6 py-4 text-sm text-gray-600">
                    {sale.date} - {sale.time}
                  </td>
                  <td className="px-6 py-4 text-sm font-medium text-gray-800">{sale.customer}</td>
                  <td className="px-6 py-4 text-sm text-gray-600">
                    {sale.products.length} producto(s)
                  </td>
                  <td className="px-6 py-4">
                    <span className="px-3 py-1 bg-blue-100 text-blue-700 text-xs rounded-full">
                      {sale.paymentMethod}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-sm font-bold" style={{color: '#D4AF37'}}>
                    USD {sale.total}
                  </td>
                  <td className="px-6 py-4">
                    <button
                      onClick={() => {
                        setSelectedSale(sale);
                        setShowDetailModal(true);
                      }}
                      className="flex items-center gap-1 mx-auto px-3 py-1 bg-gray-100 text-gray-700 text-xs rounded hover:bg-gray-200 transition-colors"
                    >
                      <Eye className="h-3 w-3" />
                      Ver Detalle
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Detail Modal */}
      {showDetailModal && selectedSale && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            className="bg-white rounded-lg shadow-xl max-w-2xl w-full"
          >
            <div className="p-6 border-b border-gray-200 flex items-center justify-between">
              <div>
                <h3 className="text-2xl font-bold text-gray-800">Detalle de Venta</h3>
                <p className="text-sm text-gray-500 mt-1">{selectedSale.transactionNumber}</p>
              </div>
              <button onClick={() => setShowDetailModal(false)}>
                <X className="h-6 w-6 text-gray-500 hover:text-gray-700" />
              </button>
            </div>
            <div className="p-6 space-y-4">
              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <p className="text-sm text-gray-600">Cliente</p>
                  <p className="font-semibold text-gray-800">{selectedSale.customer}</p>
                </div>
                <div>
                  <p className="text-sm text-gray-600">Fecha y Hora</p>
                  <p className="font-semibold text-gray-800">{selectedSale.date} - {selectedSale.time}</p>
                </div>
                <div>
                  <p className="text-sm text-gray-600">Método de Pago</p>
                  <p className="font-semibold text-gray-800">{selectedSale.paymentMethod}</p>
                </div>
                <div>
                  <p className="text-sm text-gray-600">Total</p>
                  <p className="text-2xl font-bold" style={{color: '#D4AF37'}}>USD {selectedSale.total}</p>
                </div>
              </div>
              
              <div className="border-t border-gray-200 pt-4">
                <h4 className="font-bold text-gray-800 mb-3">Productos</h4>
                <table className="w-full">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">Producto</th>
                      <th className="px-4 py-2 text-center text-sm font-medium text-gray-700">Cantidad</th>
                      <th className="px-4 py-2 text-right text-sm font-medium text-gray-700">P. Unitario</th>
                      <th className="px-4 py-2 text-right text-sm font-medium text-gray-700">Total</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    {selectedSale.products.map((product, idx) => (
                      <tr key={idx}>
                        <td className="px-4 py-2 text-sm text-gray-800">{product.name}</td>
                        <td className="px-4 py-2 text-sm text-center text-gray-600">{product.quantity}</td>
                        <td className="px-4 py-2 text-sm text-right text-gray-600">USD {product.unitPrice}</td>
                        <td className="px-4 py-2 text-sm text-right font-semibold text-gray-800">USD {product.total}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="p-6 border-t border-gray-200 flex justify-end">
              <button
                onClick={() => setShowDetailModal(false)}
                className="px-6 py-2 text-white rounded-lg hover:opacity-90 transition-opacity"
                style={{background: 'linear-gradient(135deg, #D4AF37 0%, #C9A961 100%)'}}
              >
                Cerrar
              </button>
            </div>
          </motion.div>
        </div>
      )}

      {/* Add Sale Modal */}
      {showAddModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            className="bg-white rounded-lg shadow-xl max-w-2xl w-full"
          >
            <div className="p-6 border-b border-gray-200 flex items-center justify-between">
              <h3 className="text-2xl font-bold text-gray-800">Nueva Venta</h3>
              <button onClick={() => setShowAddModal(false)}>
                <X className="h-6 w-6 text-gray-500 hover:text-gray-700" />
              </button>
            </div>
            <div className="p-6">
              <p className="text-gray-600 text-center py-8">
                Formulario de nueva venta (funcionalidad simulada)
              </p>
            </div>
            <div className="p-6 border-t border-gray-200 flex justify-end gap-3">
              <button
                onClick={() => setShowAddModal(false)}
                className="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
              >
                Cancelar
              </button>
              <button
                onClick={() => {
                  alert('Venta guardada (simulado)');
                  setShowAddModal(false);
                }}
                className="px-6 py-2 text-white rounded-lg hover:opacity-90 transition-opacity flex items-center gap-2"
                style={{background: 'linear-gradient(135deg, #D4AF37 0%, #C9A961 100%)'}}
              >
                <Save className="h-5 w-5" />
                Guardar Venta
              </button>
            </div>
          </motion.div>
        </div>
      )}
    </div>
  );
};

export default Sales;